export const content = `
id
title
imageUrl
cds
ageRating
responsiveImageUrls {
  url
  width
}
`;

export const fullContent = `
${content}
stationGames {
  station {
    id
  }
}
`;
